import { connectWithStore } from '@common/connectWithStore';
import { getContractLength, defaultContractLength } from '@redux/ducks/global';
import { getState, switchPeriod } from '@redux/ducks/account/pricingPlan/pricingPlans';
import { PricingPeriodSwitch } from './PricingPeriodSwitch';

const mapStateToProps = state => {
  const { canSwitchPeriod, planPeriod } = getState(state);
  const contractLength = canSwitchPeriod ? defaultContractLength : getContractLength(state);

  return {
    canSwitchPeriod,
    planPeriod,
    contractLength,
  };
};

const mapStateToDispatch = {
  switchPeriod,
};

export const PricingPeriodSwitchContainer = connectWithStore(mapStateToProps, mapStateToDispatch)(PricingPeriodSwitch);
